import { render, staticRenderFns } from "./CmgStaticPage.vue?vue&type=template&id=6c872ec2&scoped=true&lang=pug&"
import script from "./cmg-static-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-static-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgStaticPage.vue?vue&type=style&index=0&id=6c872ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c872ec2",
  null
  
)

export default component.exports